import React from 'react';
import './OpeningHours.css'; // CSS pour les horaires

// Données d'exemple pour les horaires (MISES À JOUR AVEC LES BONNES INFOS)
const hoursData = [
  { day: "Lundi", hours: "Fermé" },
  { day: "Mardi", hours: "09:00–13:00 / 16:00–19:00" },
  { day: "Mercredi", hours: "09:00–13:00 / 16:00–19:00" },
  { day: "Jeudi", hours: "09:00–13:00 / 16:00–22:00" },
  { day: "Vendredi", hours: "09:00–13:00 / 16:00–22:00" },
  { day: "Samedi", hours: "09:00–22:00" },
  { day: "Dimanche", hours: "Fermé" }
];

function OpeningHours() {
  return (
    <div className="opening-hours-container">
      <h3 className="hours-title">Nos Horaires</h3>
      <ul className="hours-list">
        {hoursData.map(item => (
          <li key={item.day} className="hours-item">
            <span className="day-name">{item.day}</span>
            <span className="hours-details">{item.hours}</span>
          </li>
        ))}
      </ul>
      <p className="hours-note">
        Les horaires peuvent varier les jours fériés. N'hésitez pas à nous appeler au 05 62 63 19 60 !
      </p>
    </div>
  );
}

export default OpeningHours;